module.exports = __webpack_public_path__ + "img/hotelawards.37a419db.jpg";